import React from 'react'

import classes from './DataRow.scss'

import InputGroup from '../../../../../../UI/Forms/InputGroup/InputGroup'

import { IconButton } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { updateFormOptions } from '../../../../../../../helpers/utils'

const dataRow = ({
  form,
  inputChanged,
  deleteRowClicked,
  dropdownOptions,
  currentCompany,
  currentEmp,
  disabled
}) => {
  const forms = Object.entries(form).map(item => {
    let [formKey, formAttrs] = item

    if (
      !['org_id', 'seq_no', 'position_id', 'position_group_id', 'emp_id', 'level_id'].includes(
        formKey
      )
    )
      return null

    let groupClass = []
    let inputClass = []

    if (formKey === 'seq_no') {
      groupClass = [classes.Small]
    }

    if (['input', 'datePicker'].includes(formAttrs.elementType)) {
      inputClass = [classes.FixHeight]
    }

    let formWithOptions = null

    if (formKey === 'org_id') {
      let dropdownFilter =
        dropdownOptions.empOptions.find(emp => emp.emp_id === form.emp_id.value?.value)
          ?.empdetails || []

      let orgFilter = dropdownFilter.map(res => +res.org_id) || []

      formWithOptions = updateFormOptions(
        dropdownOptions.orgOptions.filter(item => orgFilter.includes(item.org_id)),
        { ...formAttrs },
        'org_id',
        'org_id',
        { code: 'org_code', name: 'org_name' },
        'Select Organization',
        false,
        false
      )
    } else if (formKey === 'position_id') {
      let dropdownFilter =
        dropdownOptions.empOptions.find(emp => emp.emp_id === form.emp_id.value?.value)
          ?.empdetails || []

      let positionFilter = dropdownFilter.map(res => +res.position_id) || []
      formWithOptions = updateFormOptions(
        dropdownOptions.positionOptions.filter(item => positionFilter.includes(item.position_id)),
        { ...formAttrs },
        'position_id',
        'position_id',
        'position_name',
        'Select Position',
        false,
        false
      )
    } else if (formKey === 'position_group_id') {
      formWithOptions = updateFormOptions(
        dropdownOptions.positionGroupOptions,
        { ...formAttrs },
        'position_group_id',
        'position_group_id',
        { code: 'position_group_id', name: 'position_group_name' },
        'Select Position Group',
        false,
        false
      )
    } else if (formKey === 'emp_id') {
      formWithOptions = updateFormOptions(
        dropdownOptions.empOptions.filter(item => item.emp_code !== currentEmp),
        { ...formAttrs },
        'emp_id',
        'emp_id',
        { code: 'emp_code', name: 'full_name' },
        'Select Emp',
        false,
        false
      )
    } else if (formKey === 'level_id') {
      formWithOptions = updateFormOptions(
        dropdownOptions.empLevelOptions.filter(item => item.company_id === currentCompany),
        { ...formAttrs },
        'level_id',
        'level_id',
        'level_name',
        'Select Level',
        false,
        false
      )
    } else {
      formWithOptions = { ...formAttrs }
    }

    if (disabled) {
      formWithOptions.elementConfig = {
        ...formWithOptions.elementConfig,
        disabled: disabled
      }
    }
    return (
      <InputGroup
        key={formKey}
        // overrideClass={overrideClass}
        groupClass={groupClass.join(' ')}
        inputClass={inputClass.join(' ')}
        label={formWithOptions.label}
        inputType={formWithOptions.elementType}
        configs={formWithOptions.elementConfig}
        invalid={!formWithOptions.valid}
        validations={formWithOptions.validation}
        touched={formWithOptions.touched}
        changed={e => inputChanged(formKey, e)}
        inputValue={formWithOptions.value}
        validationError={formWithOptions.error}
        noMargin
      />
    )
  })
  return (
    <div className={classes.RowWrapper}>
      {forms}
      <div className={classes.Button}>
        <IconButton disabled={disabled} color={'default'} size={'small'} onClick={deleteRowClicked}>
          <CloseIcon />
        </IconButton>
      </div>
    </div>
  )
}

export default dataRow
